import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, from, switchMap, EMPTY, map } from 'rxjs';
import { isPlatformServer } from '@angular/common';
import { AuthService } from './auth.service';
import { ContextService } from './context.service';

export interface BaseResponse<T = any> {
  success: boolean;
  data?: T;
  error?: string;
}

@Injectable({
  providedIn: 'root'
})
export class GenericApiService {
  private http = inject(HttpClient);
  private auth = inject(AuthService);
  private contextService = inject(ContextService);
  private platformId = inject(PLATFORM_ID);

  private getHeaders(): Observable<HttpHeaders> {
    if (isPlatformServer(this.platformId)) return EMPTY;
    
    return from(this.auth.waitForToken()).pipe(
      switchMap(token => {
        if (!token) throw new Error('No auth token');
        return [new HttpHeaders().set('Authorization', `Bearer ${token}`)];
      })
    );
  }

  query<T>(actionCode: string, payload?: any): Observable<T> {
    const requestPayload = {
      actionCode,
      payload,
      context: this.contextService.getWebContext()
    };

    return this.getHeaders().pipe(
      switchMap(headers => this.http.post<BaseResponse<T>>('/api/bff/query', requestPayload, { headers })),
      map(response => {
        if (!response.success) {
          throw new Error(response.error || 'API Query Failed');
        }
        return response.data as T;
      })
    );
  }
}
